import ConfirmModal from './ui/confirm-modal'
import NotificationModal from './ui/notification-modal'
import type { Feedback } from '../hooks/use-feedback'

// Renders the confirm and notification modals only — NOT the toast. `.toast`
// and `.selection-action-bar` are both `position: fixed; bottom: 24px;
// z-index: 1000` (album-list.css), so at equal z-index DOM order decides
// which paints on top. The toast must stay AFTER the selection action bar in
// album-list.tsx's JSX so it wins that stacking fight — folding it in here,
// ahead of the action bar, would let a toast fired while photos are selected
// ("Deleted 2 photos", "Cover updated") get painted over and made invisible.
export default function FeedbackHost({ feedback }: { feedback: Feedback }): JSX.Element {
  return (
    <>
      {/* Confirm Modal */}
      <ConfirmModal
        isOpen={feedback.confirm.isOpen}
        title={feedback.confirm.title}
        message={feedback.confirm.message}
        variant={feedback.confirm.variant}
        confirmText={feedback.confirm.confirmText}
        onConfirm={feedback.confirm.onConfirm}
        onCancel={feedback.closeConfirm}
      />

      {/* Notification Modal */}
      <NotificationModal
        isOpen={feedback.notification.isOpen}
        title={feedback.notification.title}
        message={feedback.notification.message}
        variant={feedback.notification.variant}
        onClose={feedback.closeNotification}
        copyableText={feedback.notification.copyableText}
        copyLabel={feedback.notification.copyLabel}
        details={feedback.notification.details}
      />
    </>
  )
}
